module.exports = __webpack_public_path__ + "media/amp_version/mobile-device-f3141d61.svg";